import { StreamTrackingData } from '../types/tracker';

const stringKeys = [
    'serviceName',
    'sid',
    'uuid',
    'monetizationModel',
    'contentPackage',
    'billingFeatureNames',
    'vitrinaTvChannelSlug',
] as const;
const numberKeys = ['contentTypeId', 'kpId', 'puid'] as const;

export const getStreamsTrackingData = (unknownStreamsTrackingData: any) => {
    const streamsTrackingData: StreamTrackingData = {};

    if (!unknownStreamsTrackingData) {
        return streamsTrackingData;
    }

    stringKeys.forEach((key) => {
        if (
            unknownStreamsTrackingData[key] &&
            typeof unknownStreamsTrackingData[key] === 'string'
        ) {
            streamsTrackingData[key] = unknownStreamsTrackingData[key];
        }
    });

    numberKeys.forEach((key) => {
        if (
            unknownStreamsTrackingData[key] &&
            typeof unknownStreamsTrackingData[key] === 'number'
        ) {
            streamsTrackingData[key] = unknownStreamsTrackingData[key] as number;
        }
    });

    return streamsTrackingData;
};
